import { render, staticRenderFns } from "./added.vue?vue&type=template&id=2e1529d5"
import script from "./added.vue?vue&type=script&lang=js"
export * from "./added.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports